<div class="track-claim-details---mobile_1842-46690">
  <span class="text-detail-status_1842-46691">Detail Status</span>
  <div class="line-583_1842-46692">
    <svg width="1" height="193" viewBox="0 0 1 193" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="0.5" y1="2.18557e-08" x2="0.499992" y2="193" stroke="#E7E7E7" />
    </svg>
  </div>
  <div class="frame-1984079684_1842-46693">

    <!-- SHIMMER while loading -->
    <ng-container *ngIf="isLoading; else content">
      <div class="frame-1984079678_1842-46694 shimmer-list">
        <div class="shimmer-item" *ngFor="let i of [1,2,3]">
          <div class="shimmer-icon"></div>
          <div class="shimmer-lines">
            <div class="shimmer-line "></div>
            <div class="shimmer-line "></div>
            <div class="shimmer-line "></div>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-template #content>
      <div *ngFor="let stage of stages; let isLast = last" class="frame-1984079678_1842-46694">

        <app-plus-animation-mobile [property1]="!stage.data.isStageCompleted ? 'Default' : 'Check'" [state]="'Active'" class="plus-animation-mobile_1842-46695">
        </app-plus-animation-mobile>

        <div class="frame-1171282501_1842-46696">
          <span class="text-cashless-claim-initiated_1842-46697">
            {{ stage.data.headerText }}
          </span>

          <span class="text-12-apr-2025---06-20-am_1842-46699">
            <ng-container *ngIf="stage.data.completionDate; else pending">
              {{ stage.data.completionDate }}
            </ng-container>
            <ng-template #pending>
              In progress
            </ng-template>
          </span>

          <span *ngIf="stage.data.isCurrentState" class="badge badge-info">
            Current Stage
          </span>

          <div class="mt-2 w-100">
            <ng-container *ngIf="stage.data.intimationNumber">
              Intimation No: {{ stage.data.intimationNumber }}
            </ng-container>
            <ng-container *ngIf="stage.data.inwardNumber">
              Inward No: {{ stage.data.inwardNumber }}
            </ng-container>
            <ng-container *ngIf="stage.data.registrationStatus">
              Status: {{ stage.data.registrationStatus }}
            </ng-container>
            <ng-container *ngIf="stage.data.documentStatus">
              | {{ stage.data.documentStatus }}
            </ng-container>
          </div>
        </div>
      </div>
    </ng-template>


  </div>
</div>